export enum Policy {
  termsOfUse = 'terms-of-use',
  cookiePolicy = 'cookie-policy',
  privacyPolicy = 'privacy-policy',
  about = 'about',
}
